<template>
    <div>
        <a-spin
            :spinning="folderLoading"
        >
            <div class="divcontainer">
                <div>
                    <span class="label">{{ folderType }} neve: </span><span class="main-description">{{ folderObj.name }}</span>
                </div>
                <div>
                    <span class="label">Utolsó frissítés: </span><span class="main-description">{{ formattedDate(folderObj.modifiedAt.date) }}</span>
                </div>
                <!-- <div>
                    <span class="label">Módosította: </span><span class="main-description">{{ folderObj.modifiedBy }}</span>
                </div> -->
                <div
                    v-if="folderType !== 'akta'"
                >
                    <span class="label">Prioritás:</span>
                    <span class="main-description">
                        <a-rate
                            :allowClear="false"
                            :disabled="true"
                            :count="5"
                            :defaultValue="folderObj.priority"
                            :value="folderObj.priority"
                        ></a-rate>
                    </span>
                </div>
                <div>
                    <span class="label">Kiemelt?: </span><span class="main-description">{{ folderObj.isEmphasized ? 'Igen' : 'Nem' }}</span>
                </div>
            </div>
            <a-divider>
            </a-divider>
            <div class="divcontainer">
                <a-divider
                    orientation="left"
                >
                    <span class="capitalize">{{ folderType }} leírása</span>
                </a-divider>
                <p class="folder-description">
                    {{ folderObj.description }}
                </p>
                <template
                    v-if="folderType === 'akta'"
                >
                    <a-divider
                        orientation="left"
                    >
                        <span class="capitalize">{{ folderType }} összegzése </span>
                    </a-divider>
                    <p class="folder-overall">
                        {{ folderObj.overall }}
                    </p>
                </template>
                <a-divider>
                </a-divider>
                <div class="buttons">
                    <a-row
                        type="flex"
                        justify="center"
                        :style="{
                            width: '100%'
                        }"
                    >
                        <a-col class="button-col" :xs="24" :sm="24" :md="7" :lg="7" >
                            <a-button
                                size="large"
                                type="primary"
                                icon="edit"
                                :style="{
                                    textTransform: 'capitalize'
                                }"
                                v-on:click="() => this.openDrawer()"
                            >
                                {{ folderType }} MÓDOSÍTÁSA
                            </a-button>
                        </a-col>
                        <a-col class="button-col" :xs="24" :sm="24" :md="7" :lg="7" >
                            <a-button
                                size="large"
                                type="primary"
                                icon="download"
                                :disabled="folderObj.files.length <= 0 && folderObj.infos.length <= 0"
                                v-on:click="getExport"
                                :loading="exportLoading"
                            >
                                EXPORT LETÖLTÉS
                            </a-button>
                        </a-col>
                        <a-col class="button-col" :xs="24" :sm="24" :md="7" :lg="7" >
                            <a-popconfirm 
                                v-if="getRoleAvaliable(['ROLE_ADVANCED_USER', 'ROLE_ADMIN'])"
                                title="Biztos törli?"
                                okText="Igen"
                                cancelText="Nem"
                                v-on:confirm="deleteCurrentFolder"
                            >
                                <a-button
                                    size="large"
                                    icon="delete"
                                    type="danger"
                                    :style="{
                                        textTransform: 'capitalize'
                                    }"
                                    :loading="folderDeleteLoading"
                                >
                                    {{ folderType }} TÖRLÉSE
                                </a-button>
                            </a-popconfirm>
                        </a-col>
                    </a-row>
                    
                </div>
            </div>
            <a-divider
                orientation="left"
            >
                Tagek
            </a-divider>
            <a-row>
            <a-col
                :span="8"
            >
                <FolderDetailsTags 
                    title="Kiről szól?"
                    :tags="folderObj.persons"
                />
            </a-col>
            <a-col
                :span="8"
            >
                <FolderDetailsTags 
                    title="Témakörök"
                    :tags="folderObj.topics"
                />
            </a-col>
            <a-col
                :span="8"
            >
                <FolderDetailsTags 
                    title="Egyéb címkék"
                    :tags="folderObj.tags"
                />
            </a-col>
            </a-row>
            <template
                v-if="folderType === 'info'"
            >
                <a-divider
                    orientation="left"
                >
                    Fájlok
                </a-divider>
                <a-button
                    type="primary"
                    icon="upload"
                    v-on:click="goToFileUpload"
                >
                    Fájlok feltöltése
                </a-button>
                <FileListTable 
                    :infoId="folderObj.id"
                    :files="folderObj.files"
                    v-on:fileTableChanged="requestFolderInfo"
                />
            </template>
            <template v-else>
                <a-divider
                    orientation="left"
                >
                    Infok
                </a-divider>
                <div class="infos-grid">
                    <div class="info-container"
                        v-for="infoObj in folderObj.infos"
                        :key="infoObj.uuid"
                    >
                        <div class="info-card-container">
                            <a-popconfirm 
                                class="info-delete"
                                title="Biztos törli az aktából??"
                                okText="Igen"
                                cancelText="Nem"
                                v-on:confirm="deleteFromAkta(infoObj.id)"
                            >
                                <a-icon
                                    :type="infoRemoveLoadingId === infoObj.id ? 'loading' : 'delete'"
                                >
                                </a-icon>
                            </a-popconfirm>
                            <InfoResult
                                :folderObj="infoObj"
                                :viewOnly="true"
                            />
                        </div>
                    </div>
                </div>
            </template>
            </a-spin>
        <a-drawer
            title="MÓDOSÍTÁS"
            :width="310"
            v-on:close="closeDrawer"
            :visible="drawerOpen"
            :wrapClassName="'drawer-container'"
        >
            <FolderForm 
                :folderType="folderObj.isInfo ? 'info' : 'akta'"
                :formData="formData"
                v-on:valuesChange="handleValuesChange"
            />
            <div class="drawer-actions">
                <a-button 
                    icon="edit"
                    type="primary"
                    v-on:click="modifyFolder"
                    :loading="modifyFolderLoading"
                >
                    Módosítás
                </a-button>
            </div>
        </a-drawer>
        
    </div>
</template>

<script>
import FileListTable from './FileListTable.vue';
import uuidv4 from 'uuid/v4';
import moment from 'moment';

import FolderForm from '@/components/app/new_folder_components/FolderForm.vue';
import InfoResult from '@/components/app/info_components/InfoResult.vue';
import FolderDetailsTags from './FolderDetailsTags.vue';
import { getFolderById, deleteFolder, updateFolder, removeInfoFromFolder, getInfoExport } from '../../../http/api';

import { defaultFolderObj }from '@/helpers/defaultProps.js';


export default {
    components: {
        FileListTable,
        FolderDetailsTags,
        InfoResult,
        FolderForm
    },


    data() {
        return {
            folderObj: defaultFolderObj(),
            folderDeleteLoading: false,
            folderLoading: false,

            modifyFolderLoading: false,
            infoRemoveLoadingId: false,
            exportLoading: false,

            formData: {},

            drawerOpen: false
        }
    },

    created() {
        this.requestFolderInfo();
    },

    computed: {
        folderType() {
            return this.folderObj.isInfo ? 'info' : 'akta'
        }
    },

    watch: {
        '$route'(to, from) {

            if (to.params.id !== from.params.id) {
                this.requestFolderInfo();
            }
        }
    },

    methods: {
        deleteFromAkta(infoId) {
            this.infoRemoveLoadingId = infoId;
            const removeOptions = {
                folder_id: this.folderObj.id,
                info_id: infoId
            }
            removeInfoFromFolder(removeOptions).then(res => {
                console.log('INFOS REMOVED', res);
                this.infoRemoveLoadingId = null;
                this.requestFolderInfo();
            })
        },
        requestFolderInfo() {
            this.folderLoading = true;
            getFolderById({}, this.$route.params.id).then(res => {
                console.log('FOLDERBYIDRES', res);
                this.folderObj = {...res.data};
                this.folderLoading = false;
            })
            .catch(err => {
                console.log('FOLDERIDERR', err.response)
                if (err.response.status === 404) {
                    console.log('FOLDER NOT FOUND');
                }
                this.folderLoading = false;
            })
        },

        formattedDate(dateString) {
            return moment(dateString).format('YYYY-MM-DD hh:mm:ss');
        },

        deleteCurrentFolder() {
            this.folderDeleteLoading = true;
            deleteFolder({}, this.folderObj.uuid).then(res => {
                console.log('FOLDER DELETED', res);
                this.folderDeleteLoading = false;
                this.$router.push({
                    name: this.folderObj.isInfo ? 'infos' : 'aktas'
                })
            })
        },

        goToFileUpload() {
            this.$router.push({
                name: 'folder-file-upload',
                params: {
                    id: this.folderObj.uuid,
                    folderid: this.folderObj.id
                }
            })
        },
        openDrawer() {
            this.formData = {...this.folderObj},
            this.drawerOpen = true;
        },

        closeDrawer() {
            this.drawerOpen = false;
        },

        modifyFolder() {
            this.modifyFolderLoading = true;
            const folderOptions = {
                ...this.formData,
            };
            const folder = {
                name: folderOptions.name,
                isInfo: this.folderObj.isInfo,
                description: folderOptions.description,
                isEmphasized: folderOptions.isEmphasized,
                priority: folderOptions.priority,
                tags: folderOptions.tags.map(el => el.id),
                persons: folderOptions.persons.map(el => el.id),
                topics: folderOptions.topics.map(el => el.id),
                overall: this.folderType === 'akta' ? folderOptions.overall : ''
            }

            updateFolder(folder, this.folderObj.uuid).then(res => {
                console.log('FOLDER_UPDATED', res);
                this.modifyFolderLoading = false;
                this.closeDrawer();
                this.requestFolderInfo();
            })
        },

        handleValuesChange(changedValues) {
            this.formData = {
                ...this.formData,
                ...changedValues
            }
        },
        getRoleAvaliable(roles) {
            return this.$store.getters.getRoleAvaliable(roles);
        },


        getExport($event) {
            const parseFileName = (contentDispositionHeaderVal) => {
                const tagToSearch = 'filename="';
                const fileNameTagIndex = contentDispositionHeaderVal.indexOf(tagToSearch)
                if (fileNameTagIndex >= 0) {
                    const fileNameVal = contentDispositionHeaderVal.substring(fileNameTagIndex + tagToSearch.length, contentDispositionHeaderVal.length -1);
                    console.log('FILENAMEVAL:   ', fileNameVal);
                    return fileNameVal;
                } else {
                    return 'export.zip';
                }
            }

            $event.preventDefault();

            this.exportLoading = true;

            const options = {
                responseType: 'arraybuffer',
            }
            getInfoExport(options, this.folderObj.uuid).then(res => {
                console.log('INFOEXPORTRES', res);
                const blob = new Blob([res.data], {type: "application/zip"});
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                const fileName = `${parseFileName(res.headers['content-disposition'])}`;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.exportLoading = false;
            })
            .catch(err => {
                console.log('INIFOEXPORTERR', err);
                this.exportLoading = false;
            })

        }
    }
}
</script>

<style lang="scss" scoped>
    .divcontainer {
        max-width: 800px;
        margin: auto;

    }
    .capitalize {
        text-transform: Capitalize
    }
    div.buttons {
        display: flex;
        margin-top: 15px;
        justify-content: space-evenly;
    }
    span.label {
        font-size: 18px;
        font-weight: bold;
        text-transform: capitalize;
    }
    span.main-description {
        font-size: 24px;
        font-weight: bold;
    }

    .folder-description {
        background-color: $primary-blue;
        color: white;
        padding: 15px;
        border-radius: 8px;
    }
    .folder-overall {
        background-color: $primary-blue;
        color: white;
        padding: 15px;
        border-radius: 8px;
    }
    .infos-grid {
        display: grid;
        grid-template-columns: 1fr;

        @include md {
            grid-template-columns: 1fr 1fr;
        }
        @include xl {
            grid-template-columns: 1fr 1fr 1fr;
        }
        grid-gap: 25px;

        .info-container {
            display: flex;
        }

        .info-card-container {
            margin: auto;
            position: relative;
        }

        .info-delete {
            position: absolute;
            right: 2px;
            color: red;
            top: 3px;
            font-size: 16px;
            z-index: 1;
            cursor:pointer;
        }
    }

    .button-col {
        margin: 15px;
    }
</style>

